export class Device {
  userAgent: string;
  os: string;
  osVersion: string;
}
